class Utils {

    static maxProductsInCompare = 5;
  
    static cookieKey = "compare-products-key";
  
    static getSelectedProduct() {
      try {
        const data = localStorage.getItem(this.cookieKey);
        return data ? JSON.parse(data) : [];
      } catch (error) {
        console.error('Error getting selected products:', error);
        return [];
      }
    }
  
    static isMaxProductCounter (){
      return this.maxProductsInCompare;
    }
    static isProductInList(productId) {
      return this.getSelectedProduct().find(product => product.id === productId);
    }
  
    static setSelectedProducts(products) {
      try {
        if (products.length > 0) {
          localStorage.setItem(this.cookieKey, JSON.stringify(products));
        } else {
          localStorage.removeItem(this.cookieKey);
        }
      } catch (error) {
        console.error('Error setting selected products:', error);
      }
    }
  
    static addToProductList(productId, productUrl) {
      let products = this.getSelectedProduct();
      if (products.length >= this.maxProductsInCompare) {
        return false;
      }
  
      const productExists = products.some(product => product.id === productId);
      if (productExists) {
          return true;
      }
  
      products.push({ id: productId, url: productUrl });
      this.setSelectedProducts(products);
      this.updateProductCheckbox(products);
      window.dispatchEvent(
        new CustomEvent("compare-products-changed", { detail: products })
      );
      return true;
    }
  
    static removeFromProductList(productId) {
      let products = this.getSelectedProduct();
      if (products && products.length > 0) {
        products = products.filter(product => product.id !== productId);
        this.setSelectedProducts(products);
        this.updateProductCheckbox(products);
        window.dispatchEvent(new CustomEvent('compare-products-changed', { detail: products }));
      }
    }
  
    static updateProductCheckbox(products = null) {
      products = products || this.getSelectedProduct();
  
      const isLimitReached = products.length >= this.maxProductsInCompare;
  
      document.querySelectorAll(".item-checkbox").forEach(checkbox => {
        const isInList = products.some(
          product => product.id === checkbox.dataset.productId
        );
  
        checkbox.checked = isInList;
  
        if (isLimitReached && !isInList) {
          checkbox.disabled = true;
        } else {
          checkbox.disabled = false;
        }
      });
    }
  
    static clearList() {
      const products = this.getSelectedProduct();
      products &&
        products.forEach(product => {
          this.removeFromProductList(product.id);
        });
    }
}